import cls from "./product.module.scss"
import Link from "next/link";
import React, {FC} from "react";
import {IProduct, TranslationsType} from "../../../../types/homePageTypes";
import {Capacity, AnnualElectricity, OperationDate} from "../../../../svg";

interface IProps {
    product: IProduct;
    translationsData: TranslationsType
}

const RightArrow = () => {
    return <div className="builder-button">
        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv" focusable="false" aria-hidden="true"
             viewBox="0 0 24 24" data-testid="ArrowForwardIcon">
            <path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
        </svg>
    </div>
}

const VirtualProductCard: FC<IProps> = ({product, translationsData}) => {
    const {virtualAttributes: {
        capacity = "", location = "",
        annual_electricity_production: electricity = "",
        commercial_operation_date: commercial = "",
        solar_modules = ""
    } = {}} = product || {}
    const showReadMore = product.flats[0].visible_individually === 1;

    return (
        <div className={cls.main}>
            <div className={cls["left-column"]}>
                {showReadMore ? (
                    <Link href={`/${product?.flats?.[0]?.url_key}`} prefetch={false}>
                        <a className={cls.product__name}>{product?.flats?.[0]?.name}</a>
                    </Link>)
                    : <p className={cls.product__name}>{product?.flats?.[0]?.name}</p>
                }
                {location && <p className={cls.location__text}>{product?.virtualAttributes?.location}</p>}
                {/*<button className={cls["read-more"]}>*/}
                {/*    Read more <RightArrow />*/}
                {/*</button>*/}
                {showReadMore && <Link href={`/${product?.flats?.[0]?.url_key}`} prefetch={false}>
                    <a href={`/${product?.flats?.[0]?.url_key}`} style={{width: "max-content"}}>
                        <button className={cls["read-more"]}>
                            {translationsData?.ReadMore} <RightArrow/>
                        </button>
                    </a>
                </Link>}
            </div>
            <div className={cls["right-column"]}>
                <div className={cls["info-product-wrap"]}>
                {capacity && <div className={cls["each-info-product"]}>
                        <Capacity/> <p><b>{capacity}</b></p>
                    </div>}
                    {electricity && <div className={cls["each-info-product"]}>
                        <AnnualElectricity/> <p><b>{electricity}</b></p>
                    </div>}
                    {commercial && <div className={cls["each-info-product"]}>
                        <OperationDate/> <p><b>{commercial}</b></p>
                    </div>}
                </div>
                {solar_modules && <p className={cls["solar-desc"]}>
                    {product?.virtualAttributes?.solar_modules}
                </p>}
            </div>
        </div>
    )
}

export default VirtualProductCard;
